module.exports = __webpack_public_path__ + "static/115-e068c9613a400728a079249c012058f6.png";